import axios from "axios";

const axiosMockInstance = axios.create();

export default axiosMockInstance;
